import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const FreemiumIconWrap = ({ children, className }) => (
  <div
    className={classNames({
      'freemium-icon-wrap': true,
      [className]: !!className,
    })}
  >
    {children}
  </div>
);

FreemiumIconWrap.propTypes = propTypes;

export default FreemiumIconWrap;
